import React, { useEffect, useState, useMemo, useCallback } from "react";
import { 
    collection, getDocs, doc, updateDoc, serverTimestamp, query, where, getDoc, arrayUnion
} from "firebase/firestore"; 
import { FIRESTORE_DB } from "../../Database/Database"; 
import { NavBarDashboard } from "../../Components/NavBarDashboard/NavBarDashboard";
import { FooterDashboard } from "../../Components/FooterDashboard/FooterDashboard";

import { 
    Container, Row, Col, Card, Button, Spinner, Form, Alert, Badge, 
    Table, ListGroup, InputGroup
} from "react-bootstrap";
// Reutiliza tus componentes
import { BuscadorProductos } from "./components/BuscadorProductos"; 
import { ListaProductos } from "./components/ListaProductos";
import { Carrito } from "./components/Carrito"; 

import { generarIDTicket } from "./helpers/generarIDTicket";
import { registrarVenta } from "./api/ventas";


// ======================================================================
// LÓGICA DE FECHA (Vencimiento de Seña - Ejemplo: 30 días)
// ======================================================================
const calcularFechaVencimiento = () => {
    const date = new Date();
    date.setDate(date.getDate() + 30); // 30 días de reserva por defecto
    return date;
};

// Helper para convertir Firebase Timestamp a Date
const toDate = (timestamp) => {
    // Manejo de posibles objetos Date ya convertidos o TimeStamps de Firestore
    return timestamp instanceof Date ? timestamp : (timestamp && timestamp.toDate ? timestamp.toDate() : null);
};


const VentaSenia = () => {
    const [productos, setProductos] = useState([]);
    const [filtros, setFiltros] = useState({ codigo: "", categoria: "", proveedor: "", nombre: "" });
    const [carrito, setCarrito] = useState([]);
    const [loading, setLoading] = useState(false);
    const [flashMessage, setFlashMessage] = useState(null);

    // ESTADOS PARA REGISTRO DE SEÑA
    const [clienteNombre, setClienteNombre] = useState("");
    const [clienteTelefono, setClienteTelefono] = useState(""); 
    
    const [montoSenia, setMontoSenia] = useState(0);
    const [metodoPagoSenia, setMetodoPagoSenia] = useState("efectivo");
    const [vendedorSenia, setVendedorSenia] = useState(null);

    //ESTADO PARA NOTA CREDITO 
    // ========= NOTA DE CRÉDITO =========
const [numeroNotaCredito, setNumeroNotaCredito] = useState("");
const [notaCreditoActiva, setNotaCreditoActiva] = useState(null);
const [loadingNC, setLoadingNC] = useState(false);

    
    // ESTADOS PARA BUSCADOR Y CIERRE
    const [referenciaBusqueda, setReferenciaBusqueda] = useState("");
    const [señaEncontrada, setSeñaEncontrada] = useState(null);
    const [loadingBusqueda, setLoadingBusqueda] = useState(false); 
    const [montoFinalPago, setMontoFinalPago] = useState(0);
    const [metodoPagoFinal, setMetodoPagoFinal] = useState("efectivo");
    
    // ESTADOS PARA LISTADO DE SEÑAS PENDIENTES
    const [seniasPendientes, setSeniasPendientes] = useState([]);
    const [loadingSenias, setLoadingSenias] = useState(false);

    //ESTADOS PARA MANEJO NOTA CREDITO
    

    // METODOS DE PAGO DISPONIBLES
    const metodosPago = ["efectivo", "tarjeta", "transferencia", "mercadopago", "modo", "Nota Credito"];

    const showFlashMessage = useCallback((message, variant = 'info') => {
        setFlashMessage({ message, variant });
        const timeout = setTimeout(() => {
            setFlashMessage(null);
        }, 5000); 
        return () => clearTimeout(timeout);
    }, []);

    // ----------------------------------------------------------------------
    // Carga de Datos Iniciales (Productos y Señas Pendientes)
    // ----------------------------------------------------------------------
    const loadData = async () => {
        setLoading(true);
        setLoadingSenias(true); 
        try {
            // Cargar Productos
            const snapProductos = await getDocs(collection(FIRESTORE_DB, "productos"));
            const listProductos = snapProductos.docs.map((d) => ({ id: d.id, ...d.data() }));
            setProductos(listProductos);

            // Cargar Vendedores (Placeholder)
            setVendedorSenia({ id: "vendedor_seña_defecto", nombre: "CAJA" }); 
            
            // Cargar SEÑAS PENDIENTES (solo las que tienen estado 'seña_pendiente')
            const q = query(
                collection(FIRESTORE_DB, "ventas"), 
                where("origenVenta", "==", "Seña"),
                where("estado", "==", "seña_pendiente")
            );
            
            const snapSenias = await getDocs(q);
            const listSenias = snapSenias.docs.map((d) => {
                const data = d.data();
                return { 
                    id: d.id, 
                    ...data, 
                    fechaVencimientoDate: toDate(data.fechaVencimientoSenia),
                    cliente: data.cliente || '', 
                    clienteTelefono: data.clienteTelefono || '',
                    referenciaSenia: data.referenciaSenia || ''
                };
            });

            // Ordenar por fecha de vencimiento más cercana (ascendente)
            listSenias.sort((a, b) => a.fechaVencimientoDate.getTime() - b.fechaVencimientoDate.getTime());

            setSeniasPendientes(listSenias);

        } catch (error) {
            showFlashMessage("Error al cargar datos iniciales. Verifique su conexión.", 'danger');
            console.error(error);
        } finally {
            setLoading(false);
            setLoadingSenias(false);
        }
    };

    //NUEVA FUNCION NOTA CREDITO 

    const consultarNotaCredito = async () => {
    if (!numeroNotaCredito.trim()) {
        return showFlashMessage("Ingrese un número de Nota de Crédito", "danger");
    }

    setLoadingNC(true);

    try {
        const q = query(
            collection(FIRESTORE_DB, "notasCredito"),
            where("numeroNC", "==", numeroNotaCredito.trim()),
            where("estado", "in", ["emitida", "parcialmente_usada"])
        );

        const snap = await getDocs(q);

        if (snap.empty) {
            setNotaCreditoActiva(null);
            showFlashMessage("Nota de crédito no encontrada o ya utilizada.", "danger");
            return;
        }

        const docRef = snap.docs[0];
        const data = docRef.data();

        setNotaCreditoActiva({
            id: docRef.id,
            ...data
        });

        showFlashMessage(`Nota de crédito aplicada: $${data.montoRestante}`, "success");

    } catch (error) {
        console.error(error);
        showFlashMessage("Error al consultar nota de crédito", "danger");
    } finally {
        setLoadingNC(false);
    }
};

//TERMINA ACA FUNCION NC

    useEffect(() => {
        loadData();
    }, []);

    // ----------------------------------------------------------------------
    // LÓGICA DE FILTROS Y CARRITO (Sin cambios importantes) 
    // ----------------------------------------------------------------------
    
    const categorias = useMemo(() => {
        const s = new Set();
        productos.forEach(p => p.categoria && s.add(p.categoria));
        return Array.from(s);
    }, [productos]);

    const proveedores = useMemo(() => {
        const s = new Set();
        productos.forEach(p => p.proveedor && s.add(p.proveedor));
        return Array.from(s);
    }, [productos]);

    const productosFiltrados = useMemo(() => {
        return productos.filter(p => {
            if (filtros.codigo && !(String(p.codigoProducto || "").toLowerCase().includes(filtros.codigo.toLowerCase()))) return false;
            if (filtros.categoria && p.categoria !== filtros.categoria) return false;
            if (filtros.proveedor && p.proveedor !== filtros.proveedor) return false;
            if (filtros.nombre && !(String(p.nombreProducto || "").toLowerCase().includes(filtros.nombre.toLowerCase()))) return false;
            return true;
        });
    }, [productos, filtros]);

    const agregarAlCarrito = (prod) => {
        const exists = carrito.find(p => p.id === prod.id);
        if (exists) {
            if (exists.cantidad + 1 > prod.stock) {
                return showFlashMessage(`Stock insuficiente para ${prod.nombreProducto}. Stock actual: ${prod.stock}`, 'warning');
            }
            setCarrito(carrito.map(p => p.id === prod.id ? { ...p, cantidad: p.cantidad + 1 } : p));
        } else {
            if (1 > prod.stock) {
                 return showFlashMessage(`Stock insuficiente para ${prod.nombreProducto}. Stock actual: ${prod.stock}`, 'warning');
            }
            setCarrito([...carrito, { ...prod, cantidad: 1, stock: prod.stock }]);
        }
    };

    const cambiarCantidad = (id, cantidad) => {
        const prod = carrito.find(p => p.id === id);
        if (!prod || cantidad <= 0) return;
        if (cantidad > prod.stock) {
             return showFlashMessage(`Stock insuficiente. Máximo disponible: ${prod.stock}`, 'warning');
        }
        setCarrito(carrito.map(p => p.id === id ? { ...p, cantidad } : p));
    };

    const quitarDelCarrito = (id) => {
        setCarrito(carrito.filter(p => p.id !== id));
    };

    const limpiarFiltros = () => setFiltros({ codigo: "", categoria: "", proveedor: "", nombre: "" });
    const limpiarCarrito = () => setCarrito([]);

    const totalSinDescuento = useMemo(() => {
        return carrito.reduce(
            (s, it) => s + (Number(it.precioFinal || 0) * it.cantidad),
            0
        );
    }, [carrito]);
    
    const totalFinal = totalSinDescuento; 

  const totalPendiente = useMemo(() => {
    const final = totalFinal || 0;
    const senia = Number(montoSenia) || 0;
    const credito = notaCreditoActiva ? Number(notaCreditoActiva.montoRestante || 0) : 0;

    const total = final - senia - credito;
    return total > 0 ? total : 0;
}, [totalFinal, montoSenia, notaCreditoActiva]);


    // ----------------------------------------------------------------------
    // Lógica de Registro de Seña (Guarda estado: "seña_pendiente")
    // ----------------------------------------------------------------------

    const handleRegistrarSenia = async () => {
        if (carrito.length === 0) return showFlashMessage("El carrito está vacío.", 'danger');
        if (!clienteNombre.trim()) return showFlashMessage("Debe ingresar el nombre del cliente.", 'danger');
        if (!clienteTelefono.trim()) return showFlashMessage("Debe ingresar el teléfono del cliente.", 'danger'); 
        const montoNC = notaCreditoActiva ? Number(notaCreditoActiva.montoRestante || 0) : 0;

if ((Number(montoSenia) + montoNC) <= 0) {
    return showFlashMessage("Debe ingresar dinero o utilizar una Nota de Crédito.", 'danger');
}

        if (Number(montoSenia) >= totalFinal) return showFlashMessage("El monto de la seña no puede ser igual o mayor al total.", 'danger');
        if (!vendedorSenia) return showFlashMessage("Error: Vendedor no configurado.", 'danger');

        setLoading(true);
        const numeroReferenciaSenia = generarIDTicket(); 
        
        const ventaPayload = {
            ticketId: numeroReferenciaSenia, 
            
            // 🛑 ESTADO: Seña Pendiente (No cuenta en estadísticas aún)
            estado: "seña_pendiente", 
            estadoPago: "Seña Abonada",
            origenVenta: "Seña",
            cliente: clienteNombre.trim(),
            clienteTelefono: clienteTelefono.trim(), 
            
            referenciaSenia: numeroReferenciaSenia,
            
            montoSenia: Number(montoSenia) + montoNC,

            montoCreditoUsado: montoNC,
numeroNotaCreditoUsada: notaCreditoActiva ? notaCreditoActiva.numeroNC : null,
idNotaCreditoUsada: notaCreditoActiva ? notaCreditoActiva.id : null,

            totalPendiente: totalPendiente,
            metodoPagoSenia: metodoPagoSenia,
            fechaVencimientoSenia: calcularFechaVencimiento(), 
            
            // DATOS DE LA VENTA
         productos: carrito.map(it => ({
  idProducto: it.id,
  codigoProducto: it.codigoProducto,
  nombre: it.nombreProducto,
  cantidad: it.cantidad,

  precioUnitario: Number(it.precioFinal || 0),
  precioCosto: Number(it.precioCosto || it.costo || 0), // ✅ CLAVE

  subtotal: Number(it.precioFinal || 0) * Number(it.cantidad || 1)
})),

            totalSinDescuento: totalFinal,
            totalFinal: totalFinal, 
            
            vendedor: vendedorSenia,
            fecha: serverTimestamp(), // Fecha de la seña

            
        };

        try {
            const res = await registrarVenta(ventaPayload);
            if (!res || !res.success) throw new Error("Error desconocido al registrar seña");
            
            // Actualización de Stock
            for (const item of carrito) {
                const productoRef = doc(FIRESTORE_DB, "productos", item.id);
                const nuevoStock = Number(item.stock || 0) - item.cantidad; 
                await updateDoc(productoRef, { stock: nuevoStock });
            }

            // 👉 SI USÓ NOTA DE CRÉDITO, MARCARLA COMO USADA
if (notaCreditoActiva) {
    const ncRef = doc(FIRESTORE_DB, "notasCredito", notaCreditoActiva.id);

    await updateDoc(ncRef, {
        montoRestante: 0,
        estado: "usada",
        usadasEn: arrayUnion({
            tipo: "SEÑA",
            referencia: numeroReferenciaSenia,
            fechaUso: new Date()
        })
    });

    setNotaCreditoActiva(null);
    setNumeroNotaCredito("");
}


            

            showFlashMessage(`Seña registrada (Referencia: #${numeroReferenciaSenia}). Stock reservado.`, 'success');
            
            limpiarCarrito();
            setClienteNombre("");
            setClienteTelefono(""); 
            setMontoSenia(0);
            
            await loadData(); 

        } catch (err) {
            console.error(err);
            showFlashMessage("Error al registrar la seña.", 'danger');
        }

        setLoading(false);
    };


    // ----------------------------------------------------------------------
    // LÓGICA DE FILTRADO DINÁMICO
    // ----------------------------------------------------------------------
    const seniasFiltradas = useMemo(() => {
        const searchValue = String(referenciaBusqueda).trim().toUpperCase();
        
        if (!searchValue) {
            // Si el campo de búsqueda está vacío, mostramos el listado completo
            return seniasPendientes;
        }

        // Filtramos dinámicamente con búsqueda defensiva (usando String() en cada campo)
        return seniasPendientes.filter(senia => 
            // Coincidencia parcial o exacta de Referencia
            (String(senia.referenciaSenia).toUpperCase().includes(searchValue)) || 
            // Coincidencia parcial de Nombre del Cliente
            (String(senia.cliente).toUpperCase().includes(searchValue)) || 
            // Coincidencia parcial de Teléfono
            (String(senia.clienteTelefono).toUpperCase().includes(searchValue))
        );
    }, [seniasPendientes, referenciaBusqueda]);


    // ----------------------------------------------------------------------
    // Lógica de Selección de Seña (Al hacer clic en la lista)
    // ----------------------------------------------------------------------
    const handleSeleccionarSenia = useCallback((senia) => {
        const fechaVencimientoDate = toDate(senia.fechaVencimientoSenia);
        
        // 1. Setear la seña para mostrar en la Sección 2
        setSeñaEncontrada({ 
            id: senia.id, 
            ...senia, 
            fechaVencimientoDate
        });
        
        // 2. Pre-cargar el monto de pago final
        setMontoFinalPago(senia.totalPendiente); 
        
        // 3. Actualizar el input de búsqueda con la referencia (para contexto)
        setReferenciaBusqueda(senia.referenciaSenia); 

        showFlashMessage(`Seña #${senia.referenciaSenia} de ${senia.cliente} seleccionada. Procede al cierre de venta.`, 'info');
    }, [showFlashMessage]);


    // ----------------------------------------------------------------------
    // Lógica de Cierre de Venta (Actualiza estado: "completada")
    // ----------------------------------------------------------------------
    const handleCerrarVentaSenia = async () => {
        if (!señaEncontrada) return showFlashMessage("Primero debe buscar y seleccionar una seña.", 'danger');
        
        const saldoPendiente = señaEncontrada.totalPendiente;
        const montoIngresado = Number(montoFinalPago);

        if (montoIngresado < saldoPendiente) {
            return showFlashMessage(`El monto de pago final ($${montoIngresado.toFixed(2)}) es menor al saldo pendiente ($${saldoPendiente.toFixed(2)}).`, 'danger');
        }
        
        if (!window.confirm(`¿Cerrar venta #${señaEncontrada.referenciaSenia}? Se pagará un saldo de $${saldoPendiente.toFixed(2)} con ${metodoPagoFinal}.`)) {
            return;
        }

        setLoading(true);
        const ventaRef = doc(FIRESTORE_DB, "ventas", señaEncontrada.id);
        // 🔥 recalcular costo total real (por si cambió la cantidad o producto)
const productosConCosto = señaEncontrada.productos.map(p => ({
  ...p,
  precioCosto: Number(p.precioCosto || 0)
}));

const costoTotal = productosConCosto.reduce((acc, p) => {
  return acc + (Number(p.precioCosto) * Number(p.cantidad));
}, 0);


        try {
            await updateDoc(ventaRef, {
                // ✅ ESTADO: Completada (Cuenta en estadísticas a partir de ahora)
                estado: "completada", 
                estadoPago: "Cobrado",
                
                // MODIFICACIÓN CLAVE: Campo para registrar el monto del SALDO
                montoSaldoPagado: saldoPendiente, 
                
                metodoPagoFinal: metodoPagoFinal,
                montoPagoFinal: montoIngresado,
                cambioDevuelto: montoIngresado - saldoPendiente,
                // ✅ FECHA CLAVE: Usar esta fecha para los reportes de ingresos
                fechaCierre: serverTimestamp(),
             
                 // ✅ AGREGAR
  productos: productosConCosto,
  costoTotal: costoTotal,
  esVentaFinal: true
            });

            showFlashMessage(`Venta #${señaEncontrada.referenciaSenia} cerrada y completada con éxito.`, 'success');
            setSeñaEncontrada(null);
            setReferenciaBusqueda("");
            
            await loadData(); // Recargar la lista de señas pendientes

        } catch (error) {
            console.error(error);
            showFlashMessage("Error al cerrar la venta.", 'danger');
        } finally {
            setLoading(false);
        }
    };

    // ----------------------------------------------------------------------
    // IMPRESIÓN (MOCK)
    // ----------------------------------------------------------------------
    const handlePrintTicketSenia = () => {
        showFlashMessage("Simulando impresión de ticket de seña...", 'info');
    };
    
    const handlePrintTicketFinal = () => {
         showFlashMessage("Simulando impresión de ticket de cierre de venta...", 'info');
    };


    return (
        <>
            <NavBarDashboard />
            <Container fluid className="py-4" style={{ background: "#f5f7fb", minHeight: "100vh" }}>
                
                {flashMessage && (
                    <Alert variant={flashMessage.variant} onClose={() => setFlashMessage(null)} dismissible className="mb-3">
                        {flashMessage.message}
                    </Alert>
                )}
                
                <Row className="mb-3">
                    <Col>
                        <h3>Gestión de Ventas con Seña <Badge bg="primary">RESERVA</Badge></h3>
                        <p className="text-muted">Utilice esta sección para reservar productos y registrar el pago inicial de la seña.</p>
                    </Col>
                </Row>

                {/* ----------------------------------------------------------------- */}
                {/* SECCIÓN 1: REGISTRO DE NUEVA SEÑA */}
                {/* ----------------------------------------------------------------- */}
                <Row className="mb-3">
                    <Col>
                        <Card className="shadow-sm border-0 p-3">
                            <Card.Title className="text-primary">1. Seleccionar Productos y Cliente</Card.Title>
                            <BuscadorProductos
                                filtros={filtros} 
                                setFiltros={setFiltros}
                                categorias={categorias} 
                                proveedores={proveedores} 
                                onClear={limpiarFiltros} 
                            />
                        </Card>
                    </Col>
                </Row>

                <Row className="g-4">
                    <Col xs={12} md={7}>
                        <Card className="shadow-sm border-0">
                            <Card.Body>
                                <Card.Title>Productos disponibles (Stock Actual)</Card.Title>
                                <hr />
                                <ListaProductos 
                                    productos={productosFiltrados} 
                                    onAgregar={agregarAlCarrito} 
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} md={5}>
                        <Card className="shadow-sm border-0 bg-light">
                            <Card.Body>
                                <Card.Title>Resumen de Seña</Card.Title>
                                <hr />
                                
                                {/* ENTRADA DE DATOS DE SEÑA */}
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">Nombre del Cliente</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={clienteNombre}
                                        onChange={(e) => setClienteNombre(e.target.value)}
                                        placeholder="Nombre y Apellido (Obligatorio)"
                                    />
                                </Form.Group>
                                
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">Teléfono de Contacto</Form.Label>
                                    <Form.Control
                                        type="tel" 
                                        value={clienteTelefono}
                                        onChange={(e) => setClienteTelefono(e.target.value)}
                                        placeholder="Ej: 3415555555 (Obligatorio)"
                                    />
                                </Form.Group>

                                
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">Monto de Seña ($)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        max={totalFinal}
                                        value={montoSenia}
                                        onChange={(e) => setMontoSenia(e.target.value)}
                                        placeholder="Monto entregado como seña"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
    <Form.Label className="fw-bold">Usar Nota de Crédito</Form.Label>
    <InputGroup>
        <Form.Control
            value={numeroNotaCredito}
            onChange={(e) => setNumeroNotaCredito(e.target.value)}
            placeholder="Ej: NC-000123"
        />
        <Button
            variant="secondary"
            onClick={consultarNotaCredito}
            disabled={loadingNC}
        >
            {loadingNC ? <Spinner size="sm" /> : "Aplicar"}
        </Button>
    </InputGroup>

    {notaCreditoActiva && (
        <Alert variant="success" className="mt-2 p-2">
            ✅ Nota aplicada: ${notaCreditoActiva.montoRestante}
        </Alert>
    )}
</Form.Group>

                                
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">Método de Pago de Seña</Form.Label>
                                    <Form.Select 
                                        value={metodoPagoSenia}
                                        onChange={(e) => setMetodoPagoSenia(e.target.value)}
                                    >
                                        {metodosPago.map(metodo => (
                                            <option key={metodo} value={metodo}>{metodo}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                                
                                <hr />

                                <Carrito
                                    carrito={carrito}
                                    cambiarCantidad={cambiarCantidad} 
                                    quitarDelCarrito={quitarDelCarrito} 
                                    totalSinDescuento={totalSinDescuento} 
                                    gananciaBruta={0} 
                                />

                                <hr />
                                
                                <div className="mt-3 pt-3 border-top border-dark border-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="fw-bold">TOTAL VENTA</span>
                                        <h4 className="m-0 text-dark fw-bold">${totalFinal.toFixed(2)}</h4>
                                    </div>
                                  <div className="d-flex justify-content-between align-items-center mb-1 text-danger">
    <span className="fw-bold">SEÑA EN EFECTIVO</span>
    <h4 className="m-0 text-danger fw-bold">-${Number(montoSenia).toFixed(2)}</h4>
</div>

{notaCreditoActiva && (
    <div className="d-flex justify-content-between align-items-center mb-1 text-warning">
        <span className="fw-bold">SEÑA CON NOTA DE CRÉDITO</span>
        <h4 className="m-0 text-warning fw-bold">
            -${Number(notaCreditoActiva.montoRestante).toFixed(2)}
        </h4>
    </div>
)}

                                    <div className="d-flex justify-content-between align-items-center mb-3 pt-2 border-top">
                                        <span className="fw-bold">SALDO PENDIENTE</span>
                                        <h3 className="m-0 text-success fw-bold">
                                            ${totalPendiente.toFixed(2)} 
                                        </h3>
                                    </div>
                                </div>

                                <div className="mt-3 d-grid gap-2">
                                    <Button 
                                        variant="primary" 
                                        onClick={handleRegistrarSenia} 
                                        disabled={loading || carrito.length === 0 || !clienteNombre.trim() || !clienteTelefono.trim() || totalPendiente < 0 || totalPendiente === totalFinal}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Registrando Seña...
                                            </>
                                        ) : (
                                            "Registrar Seña y Reservar Stock"
                                        )}
                                    </Button>

                                    <Button variant="outline-secondary" onClick={limpiarCarrito}> 
                                        Limpiar carrito
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
                
                {/* ----------------------------------------------------------------- */}
                {/* SECCIÓN 2: BUSCADOR Y CIERRE DE SEÑA */}
                {/* ----------------------------------------------------------------- */}
                <Row className="mt-5">
                    <Col>
                        <Card className="shadow-sm border-0">
                            <Card.Body>
                                <Card.Title className="text-primary">2. Cerrar Seña Existente (Pagar Saldo)</Card.Title>
                                <hr />

                                {/* Buscador Dinámico */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>🔎</InputGroup.Text>
                                    <Form.Control
                                        placeholder="Filtrar por Referencia, Nombre del Cliente o Teléfono"
                                        value={referenciaBusqueda}
                                        onChange={(e) => setReferenciaBusqueda(e.target.value)}
                                    />
                                </InputGroup>

                                {/* Instrucción/Resultado de Búsqueda */}
                                {!señaEncontrada && seniasFiltradas.length > 0 && referenciaBusqueda.trim() && (
                                    <Alert variant="info" className="p-2 mt-3 text-center">
                                        Se encontraron **{seniasFiltradas.length}** señas. Seleccione una de la lista de abajo para continuar.
                                    </Alert>
                                )}
                                {!señaEncontrada && !referenciaBusqueda.trim() && (
                                    <Alert variant="secondary" className="p-2 mt-3 text-center">
                                        Comience a escribir un nombre, teléfono o referencia para filtrar la lista.
                                    </Alert>
                                )}

                                {/* Datos de la Seña SELECCIONADA */}
                                {señaEncontrada && (
                                    <Alert variant="success" className="p-3 mt-3 border border-success">
                                        <h5 className="mb-3">Seña Seleccionada: Cliente {señaEncontrada.cliente}</h5>
                                        <Row>
                                            <Col md={6}>
                                                <p className="m-0"><strong>Ref. Seña:</strong> <Badge bg="primary">#{señaEncontrada.referenciaSenia}</Badge></p>
                                                <p className="m-0"><strong>Teléfono:</strong> <span className="fw-bold">{señaEncontrada.clienteTelefono || 'N/A'}</span></p> 
                                                <p className="m-0"><strong>Fecha Seña:</strong> {toDate(señaEncontrada.fecha).toLocaleDateString()}</p>
                                                <p className="m-0"><strong>Total Venta:</strong> ${señaEncontrada.totalFinal.toFixed(2)}</p>
                                            </Col>
                                            <Col md={6}>
                                                <p className="m-0"><strong>Monto Pagado:</strong> <span className="text-danger fw-bold">${señaEncontrada.montoSenia.toFixed(2)} ({señaEncontrada.metodoPagoSenia})</span></p>
                                                <p className="m-0"><strong>Saldo Pendiente:</strong> <span className="text-success fw-bold h4 m-0">${señaEncontrada.totalPendiente.toFixed(2)}</span></p>
                                                <p className="m-0"><strong>Vencimiento:</strong> <span className={`fw-bold ${señaEncontrada.fechaVencimientoDate < new Date() ? 'text-danger' : 'text-warning'}`}>{señaEncontrada.fechaVencimientoDate.toLocaleDateString()}</span></p>
                                            </Col>
                                        </Row>

                                        <hr className="my-3"/>
                                        
                                        {/* CIERRE DE VENTA */}
                                        <h5 className="mb-3">Cierre de Venta</h5>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Monto de Pago Final</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={montoFinalPago}
                                                        onChange={(e) => setMontoFinalPago(e.target.value)}
                                                        min={señaEncontrada.totalPendiente}
                                                    />
                                                    <Form.Text className="text-muted">Monto recibido (debe ser ≥ saldo).</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Método Pago Final</Form.Label>
                                                    <Form.Select 
                                                        value={metodoPagoFinal}
                                                        onChange={(e) => setMetodoPagoFinal(e.target.value)}
                                                    >
                                                        {metodosPago.map(metodo => (
                                                            <option key={metodo} value={metodo}>{metodo}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4} className="d-grid pt-3 pt-md-0">
                                                <Button 
                                                    variant="success" 
                                                    onClick={handleCerrarVentaSenia}
                                                    disabled={loading || Number(montoFinalPago) < señaEncontrada.totalPendiente}
                                                >
                                                    {loading ? <Spinner animation="border" size="sm" /> : `Cerrar Venta y Cobrar $${señaEncontrada.totalPendiente.toFixed(2)}`}
                                                </Button>
                                                {Number(montoFinalPago) > señaEncontrada.totalPendiente && (
                                                    <Alert variant="success" className="p-1 mt-1 text-center">
                                                        Cambio: ${(Number(montoFinalPago) - señaEncontrada.totalPendiente).toFixed(2)}
                                                    </Alert>
                                                )}
                                            </Col>
                                        </Row>
                                    </Alert>
                                )}
                                
                                {!señaEncontrada && referenciaBusqueda.trim() && seniasFiltradas.length === 0 && (
                                    <Alert variant="danger" className="text-center">
                                        No se encontró ninguna seña pendiente que coincida con "{referenciaBusqueda}".
                                    </Alert>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* ----------------------------------------------------------------- */}
                {/* SECCIÓN 3: LISTADO DE SEÑAS PENDIENTES (Ahora filtrado) */}
                {/* ----------------------------------------------------------------- */}
                <Row className="mt-5">
                    <Col>
                        <Card className="shadow-sm border-0">
                            <Card.Body>
                                <Card.Title className="text-primary">
                                    3. Señas Pendientes Activas ({seniasFiltradas.length} {referenciaBusqueda.trim() ? 'Filtradas' : 'Totales'})
                                </Card.Title>
                                <hr />
                                
                                {loadingSenias ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" size="sm" className="me-2" /> Cargando señas pendientes...
                                    </div>
                                ) : seniasFiltradas.length === 0 ? (
                                    <Alert variant="success" className="text-center">
                                        🎉 ¡No hay señas pendientes que coincidan con el filtro!
                                    </Alert>
                                ) : (
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <ListGroup>
                                            {seniasFiltradas.map((senia) => {
                                                const isVencida = senia.fechaVencimientoDate && senia.fechaVencimientoDate < new Date();
                                                const isSelected = señaEncontrada && señaEncontrada.id === senia.id;
                                                
                                                let variant = isVencida ? 'danger' : 'warning';
                                                if (isSelected) variant = 'success'; // Resalta la seleccionada
                                                
                                                return (
                                                    <ListGroup.Item 
                                                        key={senia.id} 
                                                        className="d-flex justify-content-between align-items-center"
                                                        action 
                                                        // Al hacer clic, se llama a la función de selección.
                                                        onClick={() => handleSeleccionarSenia(senia)}
                                                        style={{ cursor: 'pointer' }}
                                                        variant={variant}
                                                    >
                                                        <div className="flex-grow-1">
                                                            <div className="fw-bold text-dark">
                                                                Cliente: {senia.cliente} 
                                                                {isVencida && <Badge bg="danger" className="ms-2">VENCIDA</Badge>}
                                                                {isSelected && <Badge bg="dark" className="ms-2">SELECCIONADA</Badge>}
                                                            </div>
                                                            <div className="small text-muted">
                                                                Tel: {senia.clienteTelefono || 'N/A'}
                                                            </div>
                                                            <div className="small text-muted">
                                                                Ref: <span className="fw-bold text-primary">#{senia.referenciaSenia}</span>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="text-end">
                                                            <div className="fw-bold text-success">
                                                                Saldo P.: ${senia.totalPendiente.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                                                            </div>
                                                            <div className={`small fw-semibold ${isVencida ? 'text-danger' : 'text-warning'}`}>
                                                                Vence: {senia.fechaVencimientoDate.toLocaleDateString('es-AR')}
                                                            </div>
                                                        </div>
                                                    </ListGroup.Item>
                                                );
                                            })}
                                        </ListGroup>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


            </Container>
            <FooterDashboard/>
        </>
    );
};

export default VentaSenia;